import axios from 'axios';
import { useCallback, useState } from 'react';

export const call_SpoolData = async (data, urlExtension = '', urlPrefix = '') => {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_API_URL_AZURE}${process.env.REACT_APP_AUTH_PORT_POST}${urlPrefix}${process.env.REACT_APP_GET_SPOOL_DATA}${urlExtension}`,
    headers: {},
    data
  };
  const response = await axios(config);
  const responseData = response.data;

  // add transformers here if needed
  const transformedData = responseData ? responseData : [];

  return transformedData;
};

const useSpoolData = () => {
  const defaultData = {
    label: [],
    body: [],
    totalRows: 0,
    colNames: [],
    formatMasks: [],
    types: []
  };
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(defaultData);

  const execute = async (data = {}, urlExtension = '') => {
    try {
      setIsLoading(true);
      const responseData = await call_SpoolData(data, urlExtension);
      setData(responseData);
      setIsLoading(false);
      return responseData;
    } catch (e) {
      setError(e);
      setIsLoading(false);
      /* throw e; */
    }
  };

  const reset = () => {
    setIsLoading(false);
    setData(defaultData);
    setError(null);
  };

  return {
    isLoading,
    error,
    data,
    execute: useCallback(execute, []), // to avoid infinite calls when inside a `useEffect`
    reset: useCallback(reset, []) // to avoid infinite calls when inside a `useEffect`
  };
};

export default useSpoolData;
